import type { ReactNode } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import EventNoteIcon from "@mui/icons-material/EventNote";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import { AppShell as SharedShell, type NavItem } from "@workspace/admin-ui";

export { PageHeader } from "@workspace/admin-ui";

const nav: NavItem[] = [
  { to: "/", label: "Dashboard", icon: DashboardIcon },
  { to: "/pharmacists", label: "Pharmacists", icon: PeopleIcon },
  { to: "/bookings", label: "Bookings", icon: EventAvailableIcon },
  { to: "/rooms", label: "Rooms & Availability", icon: MeetingRoomIcon },
  { to: "/consultations", label: "Consultations", icon: EventNoteIcon },
];

const titleSuffix = import.meta.env.VITE_APP_TITLE_SUFFIX ?? "";

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <SharedShell title={`Pharmacy Admin${titleSuffix}`} nav={nav}>
      {children}
    </SharedShell>
  );
}
